(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["arms-of-mercy-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const landing = document.querySelector('[data-aom-landing]');
    if (!landing || landing.dataset.ready === 'true') return;
    landing.dataset.ready = 'true';
    const galleryRoot = landing.querySelector('[data-aom-gallery]');
    if (galleryRoot) {
      const rail = galleryRoot.querySelector('.aom__gallery');
      const items = [...galleryRoot.querySelectorAll('.aom__gallery-item')];
      const previous = galleryRoot.querySelector('[data-aom-gallery-prev]');
      const next = galleryRoot.querySelector('[data-aom-gallery-next]');
      const current = galleryRoot.querySelector('[data-aom-gallery-current]');
      const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const itemLeft = item => item.offsetLeft - rail.offsetLeft;
      const nearestIndex = () => items.reduce((nearest, item, index) => {
        const distance = Math.abs(itemLeft(item) - rail.scrollLeft);
        return distance < nearest.distance ? { index, distance } : nearest;
      }, { index: 0, distance: Infinity }).index;
      const updateGallery = () => {
        const index = nearestIndex();
        current.textContent = String(index + 1);
        previous.disabled = rail.scrollLeft <= 4;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      };
      const moveGallery = direction => {
        const index = nearestIndex();
        const target = Math.max(0, Math.min(items.length - 1, index + direction));
        rail.scrollTo({ left: itemLeft(items[target]), behavior: scrollBehavior });
      };
      previous.addEventListener('click', () => moveGallery(-1));
      next.addEventListener('click', () => moveGallery(1));
      rail.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        moveGallery(event.key === 'ArrowLeft' ? -1 : 1);
      });
      rail.addEventListener('scroll', updateGallery, { passive: true });
      window.addEventListener('resize', updateGallery);
      updateGallery();
    }
    const returnsLink = landing.querySelector('.aom__hero-reassurance a');
    if (returnsLink) {
      returnsLink.addEventListener('click', () => {
        const returnsDetails = landing.querySelector(returnsLink.getAttribute('href'));
        if (returnsDetails) returnsDetails.open = true;
      });
    }
    const optionsDialog = landing.querySelector('[data-aom-options-dialog]');
    if (optionsDialog) {
      const optionInputs = [...optionsDialog.querySelectorAll('[data-aom-option]')];
      const variantInput = optionsDialog.querySelector('[data-aom-options-variant]');
      const price = optionsDialog.querySelector('[data-aom-options-price]');
      const submit = optionsDialog.querySelector('[data-aom-options-submit]');
      const variants = JSON.parse(optionsDialog.querySelector('[data-aom-variants]').textContent);
      const updateOptions = () => {
        const selected = optionInputs.map(input => input.value);
        const variant = variants.find(item => item.options.every((value, index) => value === selected[index]));
        if (!variant) return;
        variantInput.value = variant.id;
        price.textContent = variant.price;
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? optionsDialog.dataset.availableLabel : optionsDialog.dataset.unavailableLabel;
      };
      landing.querySelectorAll('[data-aom-options-open]').forEach(button => button.addEventListener('click', () => optionsDialog.showModal()));
      optionsDialog.querySelector('[data-aom-options-close]').addEventListener('click', () => optionsDialog.close());
      optionsDialog.addEventListener('click', event => {
        if (event.target === optionsDialog) optionsDialog.close();
      });
      optionInputs.forEach(input => input.addEventListener('change', updateOptions));
      updateOptions();
    }
    const primaryButton = landing.querySelector('.aom__offer-card .aom__button');
    const sticky = landing.querySelector('[data-aom-sticky]');
    if (!primaryButton || !sticky || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }, { threshold: 0 });
    observer.observe(primaryButton);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["journey-home-landing"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const landing = document.querySelector('[data-jh-landing]');
    if (!landing || landing.dataset.ready === 'true') return;
    landing.dataset.ready = 'true';
    const galleryRoot = landing.querySelector('[data-jh-gallery]');
    if (galleryRoot) {
      const rail = galleryRoot.querySelector('.jh__gallery');
      const items = [...galleryRoot.querySelectorAll('.jh__gallery-item')];
      const previous = galleryRoot.querySelector('[data-jh-gallery-prev]');
      const next = galleryRoot.querySelector('[data-jh-gallery-next]');
      const current = galleryRoot.querySelector('[data-jh-gallery-current]');
      const scrollBehavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const itemLeft = item => item.offsetLeft - rail.offsetLeft;
      const nearestIndex = () => items.reduce((nearest, item, index) => {
        const distance = Math.abs(itemLeft(item) - rail.scrollLeft);
        return distance < nearest.distance ? { index, distance } : nearest;
      }, { index: 0, distance: Infinity }).index;
      const updateGallery = () => {
        const index = nearestIndex();
        current.textContent = String(index + 1);
        previous.disabled = rail.scrollLeft <= 4;
        next.disabled = rail.scrollLeft + rail.clientWidth >= rail.scrollWidth - 4;
      };
      const moveGallery = direction => {
        const index = nearestIndex();
        const target = Math.max(0, Math.min(items.length - 1, index + direction));
        rail.scrollTo({ left: itemLeft(items[target]), behavior: scrollBehavior });
      };
      previous.addEventListener('click', () => moveGallery(-1));
      next.addEventListener('click', () => moveGallery(1));
      rail.addEventListener('keydown', event => {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        event.preventDefault();
        moveGallery(event.key === 'ArrowLeft' ? -1 : 1);
      });
      rail.addEventListener('scroll', updateGallery, { passive: true });
      window.addEventListener('resize', updateGallery);
      updateGallery();
    }
    const returnsLink = landing.querySelector('.jh__hero-reassurance a');
    if (returnsLink) {
      returnsLink.addEventListener('click', () => {
        const returnsDetails = landing.querySelector(returnsLink.getAttribute('href'));
        if (returnsDetails) returnsDetails.open = true;
      });
    }
    const optionsDialog = landing.querySelector('[data-jh-options-dialog]');
    if (optionsDialog) {
      const optionInputs = [...optionsDialog.querySelectorAll('[data-jh-option]')];
      const variantInput = optionsDialog.querySelector('[data-jh-options-variant]');
      const price = optionsDialog.querySelector('[data-jh-options-price]');
      const submit = optionsDialog.querySelector('[data-jh-options-submit]');
      const variants = JSON.parse(optionsDialog.querySelector('[data-jh-variants]').textContent);
      const updateOptions = () => {
        const selected = optionInputs.map(input => input.value);
        const variant = variants.find(item => item.options.every((value, index) => value === selected[index]));
        if (!variant) return;
        variantInput.value = variant.id;
        price.textContent = variant.price;
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? optionsDialog.dataset.availableLabel : optionsDialog.dataset.unavailableLabel;
      };
      landing.querySelectorAll('[data-jh-options-open]').forEach(button => button.addEventListener('click', () => optionsDialog.showModal()));
      optionsDialog.querySelector('[data-jh-options-close]').addEventListener('click', () => optionsDialog.close());
      optionsDialog.addEventListener('click', event => {
        if (event.target === optionsDialog) optionsDialog.close();
      });
      optionInputs.forEach(input => input.addEventListener('change', updateOptions));
      updateOptions();
    }
    const primaryButton = landing.querySelector('.jh__offer-card .jh__button');
    const sticky = landing.querySelector('[data-jh-sticky]');
    if (!primaryButton || !sticky || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(([entry]) => {
      sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top > 0;
    }, { threshold: 0 });
    observer.observe(primaryButton);
  })();

  } catch(e) { console.error(e); }
})();
})();
